import React from "react";
import PropTypes from "prop-types";
import drupalSettings from "../../../../Helpers/drupalSettings";
import { gridClasses } from "../../../../Helpers/GridClasses";

const brandName = drupalSettings.ed_dashboard.brand_name;
const isTGR = brandName === "The Glenrothes";
const lang = drupalSettings.path.currentLanguage;
const contactLink = drupalSettings.ed_dashboard.contact_link;

const SignUpStep2 = ({ onComplete, fullWidth }) => {
  const contentGridClass = fullWidth
    ? gridClasses.full
    : gridClasses.withoutSidebar;

  return (
    <div className={gridClasses.container}>
      <div className={gridClasses.row}>
        <div className={`${gridClasses.full} text-center`}>
          <h1>
            {isTGR
              ? window.Drupal.t("Please verify your email")
              : window.Drupal.t(
                  "Just one more step to go, please verify your email"
                )}
          </h1>
        </div>
      </div>

      <div className={gridClasses.row}>
        <div className={`${contentGridClass} text-center`}>
          <p>
            {isTGR
              ? window.Drupal.t(
                  "Please check your inbox for a verification email from @brandName. Simply click the link in the email and complete your account set-up.",
                  {
                    "@brandName": brandName
                  }
                )
              : window.Drupal.t(
                  "Please check your inbox for a verification email from @brandName and simply click the link in the email to complete your account set-up and log in.",
                  {
                    "@brandName": brandName
                  }
                )}
          </p>
          <p
            dangerouslySetInnerHTML={{
              __html: isTGR
                ? window.Drupal.t(
                    'If you don&apos;t receive an email, please check your junk/spam folder or <a href="@contactUrl">contact us</a>.',
                    {
                      "@contactUrl": `/${lang}${contactLink}`
                    }
                  )
                : window.Drupal.t(
                    "If you don&apos;t receive an email, please check your junk folder and add us to your safe senders."
                  )
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: isTGR
                ? window.Drupal.t(
                    "Once you have completed your account set-up, you can update your preferences at any time. Please follow the link in the footer of emails or sign in to your account to adjust your preferences."
                  )
                : window.Drupal.t(
                    "Once you have completed your account set-up, you can update your communications preferences at any time in your Inner Circle account. To do this, follow the link in the footer of our emails or login to your account and click on the preferences section to update them."
                  )
            }}
          />
        </div>
      </div>

      <div className={`signup-actions ${gridClasses.row}`}>
        <div className={`${contentGridClass} text-center`}>
          <div className="signup-buttons__container">
            {onComplete ? (
              <button className="button button--tertiary" onClick={onComplete}>
                {window.Drupal.t("Close")}
              </button>
            ) : (
              <a className="button button--tertiary" href={`/${lang}`}>
                {window.Drupal.t("Back to home")}
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

SignUpStep2.propTypes = {
  onComplete: PropTypes.func,
  fullWidth: PropTypes.bool
};

SignUpStep2.defaultProps = {
  onComplete: undefined,
  fullWidth: false
};

export default SignUpStep2;
